import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/contador-opciones',
    name: 'contadorOpciones',
    component: () => import('../views/ContadorApiOpciones')
  },
  {
    path: '/contador-composition',
    name: 'contadorComposition',
    component: () => import('../views/ContadorApiComposition')
  },
  {
    path: '/contador-hooks',
    name: 'contadorHooks',
    component: () => import('../views/ContadorConHook')
  },
  {
    path: '/api-paises',
    name: 'apiPaises',
    component: () => import('../views/ConsultaApiPaises')
  },
  {
    path: '/api-paises/:cca3',
    name: 'apiPais',
    props: true,
    component: () => import('../views/ConsultaApiPais')
  },
  {
    path: '/api-paisesdinam/',
    name: 'apiPaisesDinam',
    props: true,
    component: () => import('../views/ConsultaDinamicaPaises')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
